import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Loading from "./Loading";
import tw from "tailwind-styled-components";

export const TenantDetailsLoading = () => {
  const pairs = Array(4).fill(0);
  const title = Array(3).fill(0);
  return (
    <div>
      <div className={`${styles.loadingContainer} gap-4 items-center`}>
        <div>
          <Skeleton height={90} width={90} borderRadius={50} />
        </div>
        <div>
          <div style={{ marginBottom: "8px" }}>
            <Skeleton height={15} width={500} />
          </div>
          <div className={styles.loadingContainer}>
            {pairs.map((_, index) => (
              <div key={index} style={{ marginRight: "16px" }}>
                <div style={{ marginBottom: "5px" }}>
                  <Skeleton height={15} width={100} />
                </div>
                <div>
                  <Skeleton height={15} width={80} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={`${styles.loadingContainer} ml-4 gap-4 mt-4`}>
        {title.map((_, index) => (
          <div key={index}>
            <div>
              <Skeleton height={22} width={100} borderRadius={50} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.activeLoadingContainer}>
        <Loading />
      </div>
    </div>
  );
};

export const DashboardSummaryLoading = () => {
  const pairs = Array(1).fill(0);
  return (
    <div>
      <div className={`${styles.loadingContainer} mt-12`} >
        {/* <div>
            <Skeleton height={90} width={90} borderRadius={50} />
          </div> */}
        <div >
          {/* <div style={{ marginBottom: "8px" }}>
              <Skeleton height={20} width={400} />
            </div> */}
          <div >
            {pairs.map((_, index) => (
              <div key={index} style={{
                marginRight: "16px"
              }}>
                <div style={{ marginBottom: "5px", width: '100%' }}>
                  <Skeleton height={65} width={1100} />
                </div>
              </div>
            ))}
            <div style={{
              marginRight: "16px"
            }}>
              <div style={{ marginBottom: "5px", width: '100%' }}>
                <Skeleton height={250} width={1100} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className={`${styles.loadingContainer} ml-4 gap-4 mt-4`}>
        {title.map((_, index) => (
          <div key={index}>
            <div>
              <Skeleton height={22} width={100} borderRadius={50} />
            </div>
          </div>
        ))}
      </div> */}
      {/* <div className={styles.activeLoadingContainer}>
        <Loading />
      </div> */}
    </div>
  );
};

export const DashboardLoadingSkeleton = () => {
  const pairs = Array(1).fill(0);
  const title = Array(4).fill(0);
  return (
    <div>
      <div className={`${styles.loadingContainer} gap-4items-center mt-12`}>
        <div>
          <div style={{ marginBottom: "5px" }}>
            <Skeleton height={65} width={1100} />
          </div>
          <div className="bg-gray-50 py-5 mt-4" >
            <div style={{ marginBottom: "8px", marginTop: '2px' }}>
              <Skeleton height={30} width={160} />
            </div>
            <div className={styles.loadingContainer}>
              {pairs.map((_, index) => (
                <div key={index} style={{ marginTop: "2px" }}>
                  <div style={{ marginBottom: "5px" }}>
                    <Skeleton height={30} width={150} />
                  </div>
                  <div>
                    <Skeleton height={25} width={80} style={{ marginTop: "10px" }} />
                  </div>
                </div>
              ))}
            </div>
            <div className={`${styles.loadingContainer} gap-20 mt-6 `}>
              {title.map((_, index) => (
                <div key={index}>
                  <div>
                    <Skeleton height={50} width={200} borderRadius={10} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-row gap-10 mt-6">
            <div>
              <div className="flex flex-row item-center gap-4 justify-between">
                <Skeleton height={50} width={100} />
                <Skeleton height={25} width={80} />
              </div>
              <div className={`${styles.loadingContainer} gap-8 mt-6`}>
                {title.map((_, index) => (
                  <div key={index}>
                    <div>
                      <Skeleton height={45} width={105} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="flex flex-row item-center gap-4 justify-between">
                <Skeleton height={50} width={100} />
                <Skeleton height={25} width={80} />
              </div>
              <div className={`${styles.loadingContainer} gap-8 mt-6`}>
                {title.map((_, index) => (
                  <div key={index}>
                    <div>
                      <Skeleton height={45} width={105} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export const PLLoadingSkeleton = () => {
  const pairs = Array(1).fill(0);
  const title = Array(4).fill(0);
  return (
    <div>
      <div className={`${styles.loadingContainer} gap-4items-center mt-12`}>
        <div>
          <div style={{ marginBottom: "5px" }}>
            <Skeleton height={65} width={1100} />
          </div>
          <div className="bg-gray-50 py-5 mt-4" >
            <div style={{ marginBottom: "8px", marginTop: '2px' }}>
              <Skeleton height={30} width={160} />
            </div>
            <div className={styles.loadingContainer}>
              {pairs.map((_, index) => (
                <div key={index} style={{ marginTop: "2px" }}>
                  <div style={{ marginBottom: "5px" }}>
                    <Skeleton height={30} width={150} />
                  </div>
                  <div>
                    <Skeleton height={25} width={80} style={{ marginTop: "10px" }} />
                  </div>
                </div>
              ))}
            </div>
            <div className={`${styles.loadingContainer} gap-20 mt-6 `}>
              {title.map((_, index) => (
                <div key={index}>
                  <div>
                    <Skeleton height={50} width={200} borderRadius={10} />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-row gap-10 mt-6">
            <div>
              <div className="flex flex-row item-center gap-4 justify-between">
                <Skeleton height={50} width={100} />
                <Skeleton height={25} width={80} />
              </div>
              <div className={`${styles.loadingContainer} gap-8 mt-6`}>
                {title.map((_, index) => (
                  <div key={index}>
                    <div>
                      <Skeleton height={45} width={105} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="flex flex-row item-center gap-4 justify-between">
                <Skeleton height={50} width={100} />
                <Skeleton height={25} width={80} />
              </div>
              <div className={`${styles.loadingContainer} gap-8 mt-6`}>
                {title.map((_, index) => (
                  <div key={index}>
                    <div>
                      <Skeleton height={45} width={105} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export const SummarySkeletonLoading = ({ count }) => {
  const pairs = Array(count).fill(0);
  return (
    <div>
      <div className={`${styles.loadingContainer} mt-4 ml-0 gap-4 items-center`}>
        {/* <div>
            <Skeleton height={90} width={90} borderRadius={50} />
          </div> */}
        <div>
          {/* <div style={{ marginBottom: "8px" }}>
              <Skeleton height={20} width={400} />
            </div> */}
          <div className={styles.loadingContainer}>
            {pairs.map((_, index) => (
              <div key={index} style={{ marginRight: "16px" }}>
                <div style={{ marginBottom: "5px" }}>
                  <Skeleton height={80} width={170} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* <div className={`${styles.loadingContainer} ml-4 gap-4 mt-4`}>
        {title.map((_, index) => (
          <div key={index}>
            <div>
              <Skeleton height={22} width={100} borderRadius={50} />
            </div>
          </div>
        ))}
      </div> */}
      {/* <div className={styles.activeLoadingContainer}>
        <Loading />
      </div> */}
    </div>
  );
};

export const LargeSummarySkeletonLoading = ({ count }) => {
  const pairs = Array(count).fill(0);
  return (
    <div>
      <div className={`${styles.loadingContainer} mt-4 ml-0 gap-4 items-center`}>
        <div>
          <div className={styles.loadingContainer}>
            {pairs.map((_, index) => (
              <div key={index} style={{ marginRight: "16px" }}>
                <div style={{ marginBottom: "5px" }}>
                  <Skeleton height={80} width={200} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const SkeletonBlock = ({ className }) => (
  <div className={`bg-gray-200 rounded ${className}`} />
);

export const IncomeExpenseSummarySkeleton = ({ count = 2 }) => {
  return (
    <div className="flex flex-col gap-8">
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          className="bg-white rounded-3xl border border-gray-200 overflow-hidden animate-pulse"
        >
          {/* HEADER */}
          <div className="bg-gray-100 px-5 py-4 flex justify-between items-center">
            <div className="space-y-2">
              <SkeletonBlock className="h-5 w-40" />
              <SkeletonBlock className="h-3 w-56" />
            </div>
            <SkeletonBlock className="h-4 w-16" />
          </div>

          {/* KPI ROW */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 p-5">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="border rounded-2xl p-4 space-y-2"
              >
                <SkeletonBlock className="h-3 w-24" />
                <SkeletonBlock className="h-6 w-20" />
              </div>
            ))}
          </div>

          {/* BREAKDOWNS */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 px-5 pb-5">
            {Array.from({ length: 2 }).map((_, i) => (
              <div
                key={i}
                className="bg-gray-50 rounded-2xl p-4 border border-gray-200 space-y-3"
              >
                <SkeletonBlock className="h-4 w-40 mb-2" />
                {Array.from({ length: 4 }).map((_, r) => (
                  <div key={r} className="flex justify-between">
                    <SkeletonBlock className="h-3 w-32" />
                    <SkeletonBlock className="h-3 w-20" />
                  </div>
                ))}
                <div className="border-t border-gray-200 my-2" />
                <div className="flex justify-between">
                  <SkeletonBlock className="h-3 w-32" />
                  <SkeletonBlock className="h-3 w-24" />
                </div>
              </div>
            ))}
          </div>

          {/* COLLECTION SUMMARY */}
          <div className="px-5 pb-5">
            <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200 space-y-3">
              <SkeletonBlock className="h-4 w-44 mb-2" />
              {Array.from({ length: 3 }).map((_, r) => (
                <div key={r} className="flex justify-between">
                  <SkeletonBlock className="h-3 w-36" />
                  <SkeletonBlock className="h-3 w-20" />
                </div>
              ))}
              <div className="border-t border-gray-200 my-2" />
              <div className="flex justify-between">
                <SkeletonBlock className="h-3 w-36" />
                <SkeletonBlock className="h-3 w-24" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};


export const IncomeExpenseSummarySkeletonOld = () => {
  return (
    <div className="gap-8 grid lg:grid-cols-2 animate-pulse">
      {[...Array(2)].map((_, index) => (
        <SummaryContainer key={index}>
          <SkeletonTitle className="h-6 w-1/2 bg-gray-200 rounded mb-4" />

          <TotalProfit>
            <div className="h-4 w-24 bg-gray-200 rounded" />
            <div className="h-6 w-20 bg-gray-200 rounded" />
          </TotalProfit>

          <SectionHeader>
            <div className="h-4 w-20 bg-gray-200 rounded" />
            <div className="h-5 w-16 bg-gray-200 rounded" />
          </SectionHeader>
          <SkeletonGrid>
            {[...Array(6)].map((_, i) => (
              <SummaryItem key={i}>
                <div className="h-4 w-24 bg-gray-200 rounded mb-2" />
                <div className="h-5 w-20 bg-gray-300 rounded" />
              </SummaryItem>
            ))}
          </SkeletonGrid>

          <SectionHeader>
            <div className="h-4 w-20 bg-gray-200 rounded" />
            <div className="h-5 w-16 bg-gray-200 rounded" />
          </SectionHeader>
          <SkeletonGrid>
            {[...Array(5)].map((_, i) => (
              <SummaryItem key={i}>
                <div className="h-4 w-24 bg-gray-200 rounded mb-2" />
                <div className="h-5 w-20 bg-gray-300 rounded" />
              </SummaryItem>
            ))}
          </SkeletonGrid>
        </SummaryContainer>
      ))}
    </div>
  );
};

// export const DashboardSkeleton = () => {
//   return (
//     <Container>
//       <SummaryCard className="mb-6">
//         <Line w="w-40" />
//         <Line w="w-20" small />

//       </SummaryCard>
//       <TopCards>
//         {[1, 2, 3].map((i) => (
//           <Card key={i}>
//             <HeaderRow>
//               <div className="flex items-center gap-3">
//                 <IconSkeleton />
//                 <Line w="w-28" />
//               </div>
//             </HeaderRow>


//             <BigAmount />
//             <Line w="w-24" small />

//             <StatsGrid>
//               <StatCol>
//                 <Line w="w-24" />
//                 <Line w="w-16" small />
//               </StatCol>

//               <StatCol>
//                 <Line w="w-24" />
//                 <Line w="w-16" small />
//               </StatCol>
//             </StatsGrid>
//             <FooterLine />
//           </Card>
//         ))}
//       </TopCards>

//       <GridWrap>

//         <LeftCol>
//           <ChartCard>
//             <HeaderRow>
//               <div className="flex items-center gap-3">
//                 <IconSkeleton />
//                 <Line w="w-28" />
//               </div>
//             </HeaderRow>
//             <ChartArea />
//           </ChartCard>

//         </LeftCol>
//         <LeftCol>
//           <ChartCard>
//             <HeaderRow>
//               <div className="flex items-center gap-3">
//                 <IconSkeleton />
//                 <Line w="w-28" />
//               </div>
//             </HeaderRow>
//           </ChartCard>

//         </LeftCol>
//       </GridWrap>

//     </Container>
//   );
// };

export const DashboardSkeleton = () => {
  return (
    <Container>

      <SummaryCard className="mb-6">
        <Line w="w-40" />
        <Line w="w-20" small />

      </SummaryCard>

      {/* Collection / Expense / P&L cards */}
      <TopCards>
        {[1, 2, 3].map(i => (
          <Card key={i}>
            <HeaderRow>
              <div className="flex items-center gap-3">
                <IconSkeleton />
                <Line w="w-28" />
              </div>
            </HeaderRow>

            <BigAmount />
            <Line w="w-24" small />

            <StatsGrid>
              <StatCol>
                <Line w="w-24" />
                <Line w="w-16" small />
              </StatCol>
              <StatCol>
                <Line w="w-24" />
                <Line w="w-16" small />
              </StatCol>
            </StatsGrid>

            <FooterLine />
          </Card>
        ))}
      </TopCards>

      {/* Business Impact + Complaint Summary */}
      <GridWrap>
        <SummaryCard>
          <Line w="w-40" />
          <StatsGrid className="grid-cols-3">
            {[1, 2, 3].map(i => (
              <StatCol key={i}>
                <Line w="w-20" />
                <Line w="w-16" small />

              </StatCol>
            ))}
          </StatsGrid>
        </SummaryCard>

        <SummaryCard>
          <Line w="w-40" />
          <StatsGrid className="grid-cols-3">
            {[1, 2, 3].map(i => (
              <StatCol key={i}>
                <Line w="w-20" />
                <Line w="w-16" small />

              </StatCol>
            ))}
          </StatsGrid>
        </SummaryCard>
      </GridWrap>
    </Container>
  );
};

/* =======================
   STYLES
======================= */

const Container = tw.div`py-6 bg-gray-50 animate-pulse space-y-6`;
const TopCards = tw.div`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6`;
const Card = tw.div`
  bg-white rounded-xl border border-gray-100 shadow-sm
  px-6 pt-6 pb-5 flex flex-col
`;
const HeaderRow = tw.div`flex justify-between items-center mb-6`;
const IconSkeleton = tw.div`w-10 h-10 bg-gray-200 rounded-lg`;
const BigAmount = tw.div`h-9 w-40 bg-gray-200 rounded-md mb-2`;
const StatsGrid = tw.div`grid grid-cols-2 gap-6 mt-6`;
const StatCol = tw.div`flex flex-col gap-2`;
const FooterLine = tw.div`h-3 w-48 bg-gray-200 rounded mt-6`;
const GridWrap = tw.div`grid grid-cols-1 xl:grid-cols-2 gap-6`;
const SummaryCard = tw.div`
  bg-white p-5 rounded-xl shadow-sm border border-gray-100
  flex flex-col gap-4
`;
const Line = tw.div`
  ${(p) => p.w}
  ${(p) => (p.small ? "h-3" : "h-4")}
  bg-gray-200 rounded
`;

// const Container = tw.div`py-6 bg-gray-50 animate-pulse`;
// const TopCards = tw.div`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6`;
// const Card = tw.div` bg-white rounded-xl border border-gray-100 shadow-sm px-6 pt-6 pb-5 flex flex-col`;
// const HeaderRow = tw.div`flex items-center mb-6`;
// const IconSkeleton = tw.div` w-10 h-10 bg-gray-200 rounded-lg`;
// const BigAmount = tw.div`h-9 w-40 bg-gray-200 rounded-md mb-2`;
// const StatsGrid = tw.div`grid grid-cols-2 gap-6 mt-6`;
// const StatCol = tw.div`flex flex-col gap-2`;
// const FooterLine = tw.div`h-3 w-48 bg-gray-200 rounded mt-6`;
// const Line = tw.div`${(p) => p.w} ${(p) => (p.small ? "h-3" : "h-4")} bg-gray-200 rounded`;
// const GridWrap = tw.div`grid grid-cols-1 xl:grid-cols-2 gap-6 mt-6`;
const LeftCol = tw.div` space-y-6`;
// const ChartCard = tw.div`bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex flex-col gap-4`;
// const ChartArea = tw.div`h-44 bg-gray-100 rounded`;
// const SummaryCard = tw.div`bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex flex-col gap-3`;
const SummaryContainer = tw.div`bg-white rounded-lg p-4 w-full shadow-sm`;
const SkeletonTitle = tw.h2`text-xl font-bold text-gray-800`;
const TotalProfit = tw.div`flex justify-between items-center mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200`;
const SectionHeader = tw.div`flex justify-between items-center p-3 rounded-t-lg border-b border-gray-200 mb-3`;
const SkeletonGrid = tw.div`grid grid-cols-2 md:grid-cols-3 gap-3`;
const SummaryItem = tw.div`p-3 border-b border-gray-100`;
const styles = {
  loadingContainer: "flex dispay-flex flex-row ",
  activeLoadingContainer: "justify-center flex flex-col items-center",
};
